import * as api from '../../swc-app-api/api'
import * as configuration from '../../swc-app-api/configuration'
import axios from '../common/axios'

export async function loginExternal({commit}, userInfo) {
  const config = new configuration.Configuration()
  const {loginExternalCreate} = api.LoginApiFactory(config)
  const res = await loginExternalCreate({
    data: userInfo,
  })
}

export function logout({dispatch}) {
  dispatch('common/destroyData', null, {root: true})
  const accessToken = localStorage.getItem('auth/ACCESS_TOKEN')
  const config = new configuration.Configuration({accessToken})
  const apiClient = {...api.LogoutApiFactory(config, undefined, axios)}

  return apiClient.logoutRetrieve().then(() => {
      return new Promise((resolve) => {
        localStorage.removeItem('auth/ACCESS_TOKEN')
        localStorage.removeItem('auth/REFRESH_TOKEN')
        // commit('common/SET_LOADED', false)  # TODO:
        resolve()
      })
    }
  )
}
